import { datadogRum } from '@datadog/browser-rum'
import { UserData } from '@omnea-app/fe-auth/UserSessionProvider'
import { isNotFoundApiError } from '@omnea-app/frontend/utils/error-handling/isApiErrorOfType'

export type FetchFailedTypeError = Error

export const FAILED_TO_FETCH_ERROR_MESSAGES: string[] = [
  'failed to fetch',
  // IOs Calls "failed to fetch" something else.
  // https://stackoverflow.com/questions/71280168/javascript-typeerror-load-failed-error-when-calling-fetch-on-ios
  'load failed',
] as const

const OMNEAN_SWITCHING_ORG_ERROR_IF: ((err: Error) => boolean)[] = [(err: Error) => isNotFoundApiError(err)] as const

export function isFetchFailedTypeError(err: any): err is FetchFailedTypeError {
  return err && err instanceof TypeError && FAILED_TO_FETCH_ERROR_MESSAGES.includes(err.message.toLowerCase())
}

export function isOmneanSwitchingOrgs(err: any, userData?: UserData): boolean {
  return (
    err &&
    userData &&
    userData.isOmnean &&
    err instanceof Error &&
    OMNEAN_SWITCHING_ORG_ERROR_IF.some((condition) => condition(err))
  )
}

export function onFetchFailErrors(
  errorMessage: string,
  err: any,
  context: Record<PropertyKey, unknown> = {},
  userData?: UserData
): void {
  if (isFetchFailedTypeError(err) || isOmneanSwitchingOrgs(err, userData)) {
    // We do this as this can occur without generating user impact.
    // Therefore we treat it occuring as a "warning" with the view
    // that any other cases require investigation from Sentry
    console.warn(
      errorMessage,
      JSON.stringify({
        ...context,
        // We convert the error to an object to attempt to prevent
        // the logs being rendered as error: [error Error]
        error: {
          ...err,
          name: err.name,
          message: err.message,
          stack: err.stack,
        },
      })
    )
  } else {
    datadogRum.addError(new Error(errorMessage), { ...context, error: err })
  }
}
